var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrotesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 552,
    viewBox: "0 0 552 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 552,
    height: 552,
    fill: "#F2F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M430.153 321.698H450.811L457.697 349.201H466.85L457.697 312.546H441.571L466.806 285H455.562L430.153 312.328V285H421V349.157H430.153V321.698Z",
    fill: "#058CD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M378.153 238.698H398.811L405.697 266.201H414.85L405.697 229.546H389.571L414.806 202H403.562L378.153 229.328V202H369V266.157H378.153V238.698Z",
    fill: "#058CD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.198 211.196H185.852V266.2H195.048V202.043H188.511H185.852H149.198H147.063H140.046V266.2H149.198V211.196Z",
    fill: "#058CD7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0869 266.244H94.2394L98.0312 252.776H121.741V266.201H130.893V202H130.414H103.61V202.087H103.436L91.5808 243.58H87.7019L85.0869 252.733H88.9223L85.0869 266.244ZM109.799 211.196H121.741V243.624H100.646L109.799 211.196Z",
    fill: "#058CD7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M421 266.244H430.153L433.944 252.776H457.654V266.201H466.806V202H466.327H439.523V202.087H439.349L427.494 243.58H423.615L421 252.733H424.835L421 266.244ZM445.712 211.196H457.654V243.624H436.559L445.712 211.196Z",
    fill: "#058CD7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M295.42 202.002H268.617V202.089H268.486L256.588 243.582H252.709L250.094 252.735H253.973L250.094 266.203H259.246L263.038 252.735H286.791V266.159H295.943V202.002H295.42ZM265.653 243.582L274.806 211.155H286.791V243.582H265.653Z",
    fill: "#058CD7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M250.007 222.79V222.747V222.703C250.007 211.676 241.683 202.61 231.223 202.087H208.342H204.201V266.244H213.354V243.537L230.133 243.493C241.029 243.493 249.92 234.297 249.92 222.834V222.79H250.007ZM229 234.515H213.397V211.109H229C235.189 211.109 240.201 216.34 240.201 222.79C240.201 229.284 235.189 234.515 229 234.515Z",
    fill: "#058CD7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.022 285H144.14H140V349.157H149.153V326.406L165.932 326.362C176.828 326.362 185.719 317.166 185.719 305.703V305.659V305.616C185.806 294.589 177.438 285.523 167.022 285ZM164.799 317.384H149.196V293.978H164.799C170.988 293.978 176 299.209 176 305.659C176 312.153 170.988 317.384 164.799 317.384Z",
    fill: "#058CD7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M220.068 283C204.552 283 192 298.168 192 316.865C192 335.563 204.552 350.731 220.068 350.731C235.583 350.731 248.135 335.563 248.135 316.865C248.135 298.168 235.583 283 220.068 283ZM220.068 341.578C209.651 341.578 201.196 330.508 201.196 316.865C201.196 303.267 209.651 292.153 220.068 292.153C230.484 292.153 238.939 303.223 238.939 316.865C238.983 330.464 230.484 341.578 220.068 341.578Z",
    fill: "#058CD7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M387.375 292.327C395.307 292.327 401.54 297.339 404.678 305.664C404.678 305.664 409.951 302.177 412.436 299.606C408.164 289.407 397.879 283 387.375 283C371.162 283 358 298.168 358 316.865C358 335.563 371.162 350.731 387.375 350.731C396.223 350.731 404.198 346.198 409.559 339.05C405.855 335.738 402.368 332.774 402.368 332.774C398.75 338.048 393.346 341.404 387.332 341.404C376.436 341.404 367.545 330.377 367.545 316.865C367.588 303.311 376.479 292.327 387.375 292.327Z",
    fill: "#058CD7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 285,
    width: 9,
    height: 64,
    fill: "#058CD7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 285,
    width: 9,
    height: 64,
    fill: "#058CD7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 285,
    width: 9,
    height: 64,
    fill: "#058CD7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 285,
    width: 9,
    height: 46,
    transform: "rotate(90 131 285)",
    fill: "#058CD7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 285,
    width: 9,
    height: 46,
    transform: "rotate(90 296 285)",
    fill: "#058CD7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 285,
    width: 9,
    height: 43,
    transform: "rotate(90 348 285)",
    fill: "#058CD7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 340,
    width: 9,
    height: 43,
    transform: "rotate(90 348 340)",
    fill: "#058CD7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 312,
    width: 9,
    height: 43,
    transform: "rotate(90 348 312)",
    fill: "#058CD7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 202,
    width: 9,
    height: 64,
    fill: "#058CD7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 257,
    width: 9,
    height: 55,
    transform: "rotate(90 360 257)",
    fill: "#058CD7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 202,
    width: 9,
    height: 64,
    fill: "#058CD7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 202,
    width: 9,
    height: 64,
    fill: "#058CD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrotesk);
export default __webpack_public_path__ + "static/media/grotesk.9d82d6982860f13e4c6c31bc66fa4e14.svg";
export { ForwardRef as ReactComponent };